import { useMutation } from "react-query";

import { useApi } from "../../providers/ApiProvider";
import { APQueryOptions, useAPQuery } from "../../providers/APQueryProvider";
import { DossierTerminationReason } from "../../types/Dossier";

type TerminateDossierPayload = {
  leavingEmployer: boolean;
  lastDateOfEmployment?: string;
  endDate: string;
  terminationReason: DossierTerminationReason;
  noteFromDriver?: string;
};

export const terminateDossier = (
  dossierId: string,
  options: APQueryOptions = {}
) => {
  const { fetchWithAuth } = useApi();
  const {
    defaultOnMutateError,
    defaultOnMutateSuccess,
    defaultOnMutateSettled,
  } = useAPQuery();
  const invalidateList = [
    ["dossier", dossierId],
    ["dossierStatus", dossierId],
  ];

  return useMutation({
    mutationFn: (payload: TerminateDossierPayload): Promise<string> => {
      return fetchWithAuth<string>("terminateDossier", dossierId, {
        requestOptions: { method: "post", body: JSON.stringify(payload) },
      });
    },
    onError: defaultOnMutateError(options),
    onSuccess: defaultOnMutateSuccess(options),
    onSettled: () => defaultOnMutateSettled(invalidateList),
  });
};
